/* ─────────────────────────────────────────────────────────────────────────
   Vinanest — custom cart page interactions (AJAX quantity / remove).
   Server-rendered cart is the source of truth; JS just updates it live.
   ───────────────────────────────────────────────────────────────────────── */
(function(){
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/"; }
  function money(c){
    try{ if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(c, theme.moneyFormat); }catch(e){}
    return "$" + (Number(c||0)/100).toFixed(2);
  }
  function byKey(items,key){ for(var i=0;i<items.length;i++){ if(items[i].key===key) return items[i]; } return null; }

  function rerender(c){
    if(!c){ return; }
    if(c.item_count===0){ window.location.reload(); return; }   /* show the empty state */
    /* if only dependent items remain (gift box add-on, or $0 free-gift-app items), clear them too */
    var paid=(c.items||[]).filter(function(it){ return !(it.properties && it.properties._addon) && (it.final_line_price>0); });
    if(c.items && c.items.length && paid.length===0){
      fetch(root()+"cart/clear.js",{method:"POST",headers:{"Accept":"application/json"}})
        .then(function(){ window.location.reload(); }).catch(function(){ window.location.reload(); });
      return;
    }
    var lines=document.querySelectorAll(".cl"), still=0;
    lines.forEach(function(line){
      var it=byKey(c.items, line.getAttribute("data-key"));
      if(!it){ line.parentNode && line.parentNode.removeChild(line); return; }
      still++;
      var inp=line.querySelector("input"); if(inp)inp.value=it.quantity;
      var pr=line.querySelector(".cl-price"); if(pr)pr.textContent=money(it.final_line_price);
    });
    var st=document.getElementById("cpSubtotal"); if(st)st.textContent=money(c.items_subtotal_price);
    if(still===0){ window.location.reload(); }
  }
  function change(key,qty,btn){
    if(btn)btn.disabled=true;
    fetch(root()+"cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ if(!r.ok) throw new Error("change"); return r.json(); })
      .then(function(c){ rerender(c); if(btn)btn.disabled=false; })
      .catch(function(){ window.location.reload(); });
  }
  window.vnCartQty=function(btn,delta){
    var line=btn.closest(".cl"); if(!line) return;
    var inp=line.querySelector("input");
    var q=Math.max(0, parseInt((inp&&inp.value)||"1",10)+delta);
    change(line.getAttribute("data-key"), q, btn);
  };
  window.vnCartRemove=function(btn){
    var line=btn.closest(".cl"); if(!line) return;
    change(line.getAttribute("data-key"), 0, btn);
  };
  /* typed quantity edits */
  document.addEventListener("change",function(e){
    var t=e.target;
    if(t && t.matches && t.matches(".cl input[name='updates[]']")){
      var line=t.closest(".cl"); if(!line) return;
      change(line.getAttribute("data-key"), Math.max(0, parseInt(t.value||"0",10)), null);
    }
  });
})();
